// @ts-nocheck
import * as React from "react";

const Linkedin: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                fill="currentColor"
                d="M22 22h-4v-6.999c0-1.92-.847-2.991-2.366-2.991-1.653 0-2.634 1.116-2.634 2.991V22H9V9h4v1.462s1.255-2.202 4.083-2.202C19.912 8.26 22 9.986 22 13.558V22zM4.442 6.921A2.451 2.451 0 012 4.46 2.451 2.451 0 014.442 2a2.451 2.451 0 012.441 2.46 2.45 2.45 0 01-2.441 2.461zM2 22h5V9H2v13z"
            />
        </svg>
    );
};

export default React.memo(Linkedin);
